<template>
  <div>
    <div class="title">{{ $t('comp.bssFile.title') }}:&nbsp;<span>{{ fileList.length }}</span>개</div>
    <div>
      <ul>
        <li :key="item.DWLD_URL" v-for="item in fileList" >
          <!-- @click="fileDown(item.DWLD_URL)"> -->
          <div>
            <a :href="'/ezFile/basic/down/'+item.DWLD_URL">{{ item.FILE_NM }}.{{ item.FILE_ETSION }}</a>
            <span>{{ item.FILE_SIZE }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>

export default {
  name: 'BBSFile',
  components: {
  },
  props: {
    fileList: {
      type: Array,
      default: function(){
        return [];
      },
    }
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
  .title{
    color: #555;
    padding-bottom: 10px;
    span {
      color: #0059a9;
    }
  }
  li {
    > div {
      display: flex;
      justify-content: space-between;
      a {
        cursor: pointer;
        font-size: 12pt;
        color: #555;
        &:before {
          content: "·";
          color: #0059a9;
          font-weight: 500;
        }
        &:hover {
          color: #0059a9;
        }
      }
      span {
        font-size: 10pt;
        color: #555;
      }
    }
  }
</style>
